import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import { Component, OnInit, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AuthInternalService,
  SignalRInternalService,
} from '@vinnova/auth-internal';
import { MaintenanceService } from '@vinnova/e-admin-shell';
import { Observable, map, merge } from 'rxjs';
import { environment } from '../environments/environment';

registerLocaleData(localeSv);

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly maintenanceService = inject(MaintenanceService);
  private readonly signalRService = inject(SignalRInternalService);
  private readonly authInternalService = inject(AuthInternalService);

  isAllowed$: Observable<boolean>;

  ngOnInit(): void {
    this.authInternalService
      .awaitLoginAndInitAccount()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.signalRService.init(
          [environment.etjansterCommonApiScope],
          environment.msalConfig.authority,
        );
      });

    this.isAllowed$ = merge(
      this.maintenanceService.canAccess(),
      this.signalRService.maintenanceModeActivated$.pipe(
        map((value) => !value || this.maintenanceService.hasMaintenanceRole()),
      ),
    );
  }
}
